import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { environment } from '../environment.ts/environment';

@Component({
  selector: 'app-politique-de-confidentialite',
  standalone: true,
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './politique-de-confidentialite.component.html',
  styleUrl: './politique-de-confidentialite.component.scss'
})
export class PolitiqueDeConfidentialiteComponent implements OnInit {
  supportEmail = environment.supportEmail;

  constructor(
    private title: Title,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    // Définir le titre de la page (50 caractères - optimal)
    this.title.setTitle('Confidentialité et données personnelles – PDF to Word');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'pdf-to-word.fr protège vos données personnelles : traitement, finalités, durée de conservation, sécurité, droits des utilisateurs et conformité au RGPD.' });
    this.meta.updateTag({ name: 'keywords', content: 'politique confidentialité pdf-to-word, protection données personnelles, RGPD conversion PDF, sécurité données utilisateur, vie privée pdf-to-word.fr' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Confidentialité et données personnelles – PDF to Word' });
    this.meta.updateTag({ property: 'og:description', content: 'pdf-to-word.fr protège vos données personnelles : traitement, finalités, durée de conservation, sécurité, droits des utilisateurs et conformité au RGPD.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
    this.meta.updateTag({ name: 'author', content: 'Interactive Lab' });
  }

}
